import { Button, Card, Col, Row } from 'antd';
import React from 'react';
import { IDoctorInfo } from 'src/entity/DoctorEntity';
import DoctorService from 'src/services/DoctorService';
import I18N from 'src/services/I18NService';
import SalesSearchBox from './SalesSearchBox';

interface IAssignProps {
  docInfos: IDoctorInfo[];
  onSubmit: (salespersonUuid: string | null, salespersonName: string | null) => void;
}

interface IAssignSalesState {
  uuid: string;
}

class AssignSales extends React.Component<IAssignProps, IAssignSalesState> {
  state: IAssignSalesState = {
    uuid: '',
  };

  constructor(props: IAssignProps) {
    super(props);
  }

//   componentDidMount() {
//     const docInfo = this.props.docInfos;
//     // 如果只有一个医生， 默认带出医生所属的销售员
//     if (docInfo.length === 1) {
//       this.setState({uuid: docInfo[0].salesperson_uuid});
//     }
//   }

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  async handleOk() {
    try {
        if (this.state.uuid === '-1') {
          this.props.onSubmit(null, null);
          return;
        }

        const saleInfo = await DoctorService.getSalesInfo(this.state.uuid);
        if (saleInfo) {
          const { fullname: salespersonName, uuid: salespersonUuid } = saleInfo;
          this.props.onSubmit(salespersonUuid, salespersonName);
        } else {
          this.props.onSubmit(null, null);
        }
    } catch (error) {
        console.error(error);
    }
  }

  handleChange(value: string) {
    this.setState({ uuid: value });
  }

  render() {
    const { docInfos } = this.props;
    return (
      <div>
        <Card style={{ width: 480 }}>
          <Row>
            <Col style={{ textAlign: 'right' }} span={6}>
              {`${I18N.get('nav_user_doctor')}：`}
            </Col>
            <Col span={17} offset={1}>
              {docInfos.map((doc, index) => {
                return (
                  <Row key={index}>
                    <Col span={4}>
                      {doc.last_name}
                      {doc.first_name}
                    </Col>
                    <Col span={12}>{doc.mobile}</Col>
                    <Col span={6}>{doc.salesperson_name}</Col>
                  </Row>
                );
              })}
            </Col>
          </Row>
          <Row style={{ marginTop: '20px' }}>
            <Col style={{ textAlign: 'right' }} span={6}>
              {`${I18N.get('common_assignTo')}：`}
            </Col>
            <Col span={17} offset={1}>
              <SalesSearchBox value={this.state.uuid} parentCom={'assignSales'} onChange={(value: string) => this.handleChange(value)} />
              {/* <Select
                dropdownMatchSelectWidth={false}
                allowClear={true}
                value={this.state.uuid}
                style={{ width: '240px' }}
                onChange={(value: string) => this.handleChange(value)}
                showSearch={true}
                filterOption={true}
                optionFilterProp='children'
              >
                <Select.Option value='-1'>
                  {I18N.get('doc_clear_sale')}
                </Select.Option>
                {sales.map(sale => (
                  <Select.Option key={sale.uuid} value={sale.uuid}>
                    {`${sale.department_path}-${sale.fullname}`}
                  </Select.Option>
                ))}
              </Select> */}
            </Col>
          </Row>
          <Row style={{ marginTop: '24px', textAlign: 'center' }}>
            <Button type="primary" disabled={!this.state.uuid} onClick={() => this.handleOk()}>
              {I18N.get('common_ok')}
            </Button>
          </Row>
        </Card>
      </div>
    );
  }
}

export default AssignSales;



// WEBPACK FOOTER //
// ./src/components/common/AssignSales.tsx